export const HVAC_PACKAGE_NAME = 'HVAC';

export  const planPackageLogoUrls = {
  hvac: {
    dark: '/assets/package_hvac_edition_dark.svg',
    light: '/assets/package_hvac_edition_light.svg',
  },
};

export const getPlanPackageLogo = ({ industryPackageName, isMax }: { industryPackageName: string; isMax: boolean }) => {
  if (!industryPackageName) return null;

  if (isMax) return planPackageLogoUrls.hvac.light;

  return planPackageLogoUrls.hvac.dark;
};
